<template>
  <div class="footer">
    <div class="inner">
      <a
        class="forbesnext"
        href="https://forbes.hu"
        target="_blank"
      >
        Tovább a <img
          src="../assets/forbes-foo.svg"
          alt="Forbes"
        > -ra
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {

  },
  methods: {

  },
};
</script>

<style scoped lang="css">
.footer {
  background-color: #fff;
  color: #0a0a0a;
}
.inner {
  height: 72px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
}
.forbesnext {
  color: #0a0a0a;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 12px;
  margin-right: 15px;
}
.forbesnext img {
  height: 21px;
}
</style>
